import React from 'react'
import { AddToTrolley } from '@sainsburys-tech/bolt'
import * as Styled from './DeliveryBox.styles'
import FableAddToTrolleyButton from '../../FableAddToTrolleyButton/FableAddToTrolleyButton'
import AddToTrolleyButtonWrapper from '../../AddToTrolleyButtonWrapper/AddToTrolleyButtonWrapper'

const { Button: TrolleyButton } = AddToTrolley

const clickOrigin = 'PDP:deliveryATT'

export const DeliveryTrolleyButton = ({
  addToTrolley,
  showDeliveryForm,
  onShowDeliveryForm,
  deliveryIcon,
  partNumber,
  trolleyButtonTracking,
  trolleyButtonOnErrorTracking,
  productList
}) => {
  const trackingParams = {
    clickOrigin,
    products: productList
  }
  return (
    !showDeliveryForm && (
      <Styled.FulfilmentActionRow data-test='delivery-CTA'>
        {deliveryIcon !== 'out_of_stock' && (
          <AddToTrolleyButtonWrapper>
            <TrolleyButton
              onClick={event => addToTrolley(event, false, trolleyButtonTracking)}
              onError={trolleyButtonOnErrorTracking('PDP:deliveryATT')}
              partNumber={partNumber}
              superType='tiny'
              type='secondary'
              small
              openView
              data-test='delivery-box-att'
            />
            <FableAddToTrolleyButton
              productId={partNumber}
              quantity={1}
              small
              kind='secondary'
              trackingParams={trackingParams}
            />{' '}
          </AddToTrolleyButtonWrapper>
        )}
        <a
          onClick={onShowDeliveryForm}
          onKeyPress={onShowDeliveryForm}
          role='link'
          tabIndex='0'
          data-test='delivery-box-change-postcode'
        >
          Change postcode
        </a>
      </Styled.FulfilmentActionRow>
    )
  )
}
